module.exports = __webpack_public_path__ + "img/gallery.4de73bbd.png";